import createCache from "@emotion/cache";
import type { EmotionCache } from "@emotion/cache";

const shadowCaches = new WeakMap<ShadowRoot, EmotionCache>();

/**
 * One Emotion cache per shadow root. Emotion inserts styles into the document
 * head by default, which cannot penetrate a shadow boundary — components
 * rendered inside a bfrs shadow root need their styles injected into that
 * root. The cache keeps the default `css` key so generated class names are
 * identical inside and outside shadow roots (the hash depends only on the key,
 * styles and label — all deterministic).
 *
 * `compat: true` matches the tolerant serialization used for the default
 * document cache in production; it only silences dev-time SSR heuristics that
 * do not apply inside client-only shadow mounts.
 */
export function getShadowEmotionCache(shadow: ShadowRoot): EmotionCache {
  let cache = shadowCaches.get(shadow);
  if (!cache) {
    cache = createCache({
      key: "css",
      container: shadow as unknown as HTMLElement
    });
    cache.compat = true;
    shadowCaches.set(shadow, cache);
  }
  return cache;
}
